import { render } from "./PresupuestoForm.vue?vue&type=template&id=9a46b24c"
import script from "./PresupuestoForm.vue?vue&type=script&lang=js"
export * from "./PresupuestoForm.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__